"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { CookieConsentBanner } from "@/components/cookie-consent-banner";
import { Footer } from "@/layouts/footer/footer";
import { Header } from "@/layouts/header/header";
const CHROMELESS_ROUTES = ["/solicitar-proposta"];
export function SiteShell(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const hideChrome = CHROMELESS_ROUTES.some(route => pathname.startsWith(route));
  if (hideChrome) {
    let t1;
    if ($[0] !== children) {
      t1 = <main id="main-content" data-chromeless="true">{children}</main>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a href="#main-content" className="sr-only fixed top-3 left-3 z-10001 rounded-md bg-gray-50 px-4 py-3 text-gray-1100 focus:not-sr-only">Pular para o conteúdo principal</a>;
    t2 = <Header />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <main id="main-content">{children}</main>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Footer />;
    t5 = <CookieConsentBanner />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}